// /src/pages/debug/DebugAppCheckToken.js
import { useState } from "react";
import { FiCopy, FiRefreshCw } from "react-icons/fi";

const isUuidV4 = (s) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(s || "");

// Sinh UUID v4 chuẩn bằng Web Crypto
function uuidv4() {
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40; // version 4
  b[8] = (b[8] & 0x3f) | 0x80; // variant
  const toHex = (n) => n.toString(16).padStart(2, "0");
  const s = [...b].map(toHex).join("");
  return `${s.slice(0, 8)}-${s.slice(8, 12)}-${s.slice(12, 16)}-${s.slice(16, 20)}-${s.slice(20)}`;
}

export default function DebugAppCheckToken() {
  const [token, setToken] = useState(() => localStorage.getItem("APP_CHECK_DEBUG_TOKEN") || "");
  const [msg, setMsg] = useState("");

  const save = (t) => {
    setToken(t);
    localStorage.setItem("APP_CHECK_DEBUG_TOKEN", t);
    setMsg("Saved locally");
    setTimeout(() => setMsg(""), 1200);
  };

  const applyAndReload = () => {
    const url = new URL(window.location.href);
    if (token) url.searchParams.set("appcheck_debug_token", token);
    else url.searchParams.delete("appcheck_debug_token");
    window.location.href = url.toString();
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(token || ""); setMsg("Copied!"); setTimeout(() => setMsg(""), 1200); } catch { }
  };

  return (
    <div className="max-w-xl mx-auto p-4 space-y-3">
      <h1 className="text-2xl font-bold">App Check Debug Token</h1>

      <div className="bg-card border border-border rounded-xl p-4 space-y-3">
        <label className="block text-sm font-medium">Token (UUID v4)</label>
        <input
          className="w-full border border-border rounded-lg p-2 bg-background"
          value={token}
          onChange={(e) => setToken(e.target.value.trim())}
          placeholder="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
        />
        {!isUuidV4(token) && token !== "" && (
          <div className="text-sm text-red-600">Token phải là UUID v4 hợp lệ.</div>
        )}

        <div className="flex flex-wrap gap-2">
          <button onClick={() => { const t = uuidv4(); save(t); }} className="bg-muted px-4 py-2 rounded-lg">
            Generate UUID v4
          </button>
          <button onClick={() => save(token)} className="bg-primary text-textButton px-4 py-2 rounded-lg">
            Save
          </button>
          <button onClick={copy} className="px-4 py-2 rounded-lg border inline-flex items-center gap-2">
            <FiCopy /> Copy
          </button>
          <button
            onClick={applyAndReload}
            disabled={!isUuidV4(token)}
            className="inline-flex items-center gap-2 bg-primary hover:bg-secondary text-textButton px-4 py-2 rounded-lg"
          >
            <FiRefreshCw /> Apply & Reload
          </button>
        </div>

        {msg && <div className="text-sm text-menu/70">{msg}</div>}

        <div className="text-sm text-menu/70 pt-2 border-t">
          <b>Bước 1:</b> Bấm <i>Generate UUID v4</i> hoặc dán token hợp lệ. <br />
          <b>Bước 2:</b> Copy và dán token vào <b>Firebase Console → App Check → (web app) → Debug tokens → Add</b>. <br />
          <b>Bước 3:</b> Bấm <i>Apply & Reload</i> để áp token ngay từ lúc khởi động app.
        </div>
      </div>
    </div>
  );
}
